import { Text } from '@components/rolex-ui/Text'
import Openinghours from '../Openinghours'
import { Heading } from '@components/rolex-ui/Heading'
import CtaButtons from '../CtaButtons'
import { RolexStorePageV72024 } from '@lib/kontent/models/RolexStorePageV72024'
import { Item } from '@lib/kontent'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type StoreMapInfoPanelProps = {
  item: Item<RolexStorePageV72024>
  isRCPO?: boolean
}

const StoreMapInfoPanel: FC<StoreMapInfoPanelProps> = ({ item, isRCPO }) => {
  const { t } = useTranslation('rolex')
  const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = item.elements

  const openingHours = [
    monday.value,
    tuesday.value,
    wednesday.value,
    thursday.value,
    friday.value,
    saturday.value,
    sunday.value,
  ]

  return (
    <div className={cn('lg:w-[35vw] lg:min-w-[400px]')}>
      <div className="mx-auto w-[calc(100%-2rem)] py-10 md:w-full md:px-6 xl:px-[2.75rem]">
        <Text variant="legend16" className="mb-1 text-rolexBrown">
          {t('contact.officialRetailer')}
        </Text>
        <Heading variant="headline30" as="h2" className="mb-5 text-rolexBrown">
          {item.elements.name.value}
        </Heading>
        <Text variant="fixed16" weight="light" className="mb-5 whitespace-pre-line">
          {item.elements.address_details.value}
        </Text>
        <Openinghours
          timezone={
            item.elements.country.value[0].codename === 'singapore'
              ? 'Asia/Singapore'
              : 'Europe/Amsterdam'
          }
          days={openingHours}
        />
        <CtaButtons
          phoneNumber={item.elements.phone_number.value}
          sendMessage
          directionsUrl={item.elements.google_maps_link.value}
          isRCPO={isRCPO}
        />
      </div>
    </div>
  )
}

export default StoreMapInfoPanel
